/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import getFileExtension from "./getFileExtension";

const MIMEFormats = Object.freeze({
  png: "image/png",
  jpeg: "image/jpeg",
  jpg: "image/jpg",
  webp: "image/webp",
  pdf: "application/pdf",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "application/vnd.ms-excel",
  heic: "image/heic",
});

export const getExtensionMimeType = (extension: string) => {
  return (
    MIMEFormats[extension as keyof typeof MIMEFormats] ||
    Object.values(MIMEFormats).find((m) => m === extension)
  );
};

export const mimeTypeToExtension = (mimeType: string) => {
  return Object.keys(MIMEFormats).find((m) => MIMEFormats[m as keyof typeof MIMEFormats] === mimeType);
};

export const getFileMIME = (filename: string) => {
  const ext = getFileExtension(filename) as keyof typeof MIMEFormats;
  if (ext?.length === 0 || !MIMEFormats[ext] || MIMEFormats[ext] === undefined) {
    return "";
  }
  if (MIMEFormats[ext]) {
    return MIMEFormats[ext];
  }
};

export default getFileMIME;
